export default __webpack_public_path__ + "static/media/oscer-pres-loin-pain.9838087a.svg";